import { useState } from "react";

// Editor de um widget (modal): tipo, título, métricas, dimensão e opções. Sem código, só catálogo.

const TIPOS = [
    { key: "kpi", label: "KPI", desc: "um número, com comparativo", dim: false, multi: false },
    { key: "line", label: "Linha", desc: "evolução no tempo", dim: true, multi: true },
    { key: "bar", label: "Barras", desc: "por dia ou por categoria", dim: true, multi: true },
    { key: "donut", label: "Rosca", desc: "participação por categoria", dim: true, multi: false },
    { key: "table", label: "Tabela", desc: "várias métricas por categoria", dim: true, multi: true },
    { key: "funnel", label: "Funil", desc: "métricas em sequência", dim: false, multi: true },
    { key: "creatives", label: "Criativos", desc: "cards dos anúncios com mídia", dim: false, multi: true },
    { key: "texto", label: "Texto", desc: "anotação livre", dim: false, multi: false },
];

const sel = "input-field w-full text-sm";

export default function WidgetEditor({ widget, catalogo, onSalvar, onFechar }) {
    const [w, setW] = useState(() => ({ opcoes: {}, metrics: [], ...widget }));
    const tipo = TIPOS.find(t => t.key === w.tipo) || TIPOS[0];
    const metricas = catalogo?.metricas || [];
    const dimensoes = catalogo?.dimensoes || [];
    const [busca, setBusca] = useState("");

    function toggleMetric(k) {
        setW(x => {
            const tem = x.metrics.includes(k);
            if (!tipo.multi) return { ...x, metrics: [k] };
            return { ...x, metrics: tem ? x.metrics.filter(m => m !== k) : [...x.metrics, k] };
        });
    }
    function setTipo(k) {
        const t = TIPOS.find(x => x.key === k);
        setW(x => ({ ...x, tipo: k, metrics: t.multi ? x.metrics : x.metrics.slice(0, 1), dimension: t.dim ? (x.dimension || (k === "donut" ? "origem" : k === "table" ? "campanha" : "dia")) : (k === "creatives" ? "anuncio" : undefined) }));
    }
    function salvar() {
        if (w.tipo !== "texto" && !w.metrics.length) return;
        onSalvar({ ...w, titulo: w.titulo || metricas.find(m => m.key === w.metrics[0])?.label || tipo.label });
    }
    const filtradas = metricas.filter(m => !busca || m.label.toLowerCase().includes(busca.toLowerCase()) || m.key.includes(busca.toLowerCase()));
    const grupos = [["meta", "Meta"], ["vendas", "Vendas (Metriqa)"], ["tracking", "Tracking"], ["calculada", "Calculadas"]];

    return (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-start justify-center overflow-y-auto p-4 sm:p-8" onClick={e => { if (e.target === e.currentTarget) onFechar(); }}>
            <div className="surface-card w-full max-w-3xl my-4 p-5 space-y-4">
                <div className="flex items-center justify-between">
                    <h2 className="heading-3">{widget.id ? "Editar widget" : "Novo widget"}</h2>
                    <button onClick={onFechar} className="text-ink-3 hover:text-white text-xl leading-none">✕</button>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2">
                    {TIPOS.map(t => (
                        <button key={t.key} onClick={() => setTipo(t.key)} className={`text-left p-2.5 rounded-lg border transition ${w.tipo === t.key ? "border-brand-500/50 bg-brand-500/15" : "border-white/[0.08] bg-surface-2 hover:bg-surface-3"}`}>
                            <p className="text-xs font-semibold">{t.label}</p>
                            <p className="text-[10px] text-ink-4 leading-tight">{t.desc}</p>
                        </button>
                    ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-[1fr_220px] gap-3">
                    <div>
                        <label className="text-xs text-ink-3 mb-1 block">Título</label>
                        <input value={w.titulo || ""} onChange={e => setW(x => ({ ...x, titulo: e.target.value }))} className={sel} placeholder="deixe vazio pra usar o nome da métrica" />
                    </div>
                    {tipo.dim && (
                        <div>
                            <label className="text-xs text-ink-3 mb-1 block">Agrupar por</label>
                            <select value={w.dimension || ""} onChange={e => setW(x => ({ ...x, dimension: e.target.value }))} className={sel}>
                                {dimensoes.map(d => <option key={d.key} value={d.key}>{d.label}</option>)}
                            </select>
                        </div>
                    )}
                </div>

                {w.tipo === "texto" ? (
                    <div>
                        <label className="text-xs text-ink-3 mb-1 block">Texto</label>
                        <textarea value={w.opcoes?.texto || ""} onChange={e => setW(x => ({ ...x, opcoes: { ...x.opcoes, texto: e.target.value } }))} rows={4} className={sel} />
                    </div>
                ) : (
                    <div>
                        <div className="flex items-center justify-between mb-1">
                            <label className="text-xs text-ink-3">Métricas {tipo.multi ? "(várias, na ordem em que clicar)" : "(uma)"}</label>
                            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="buscar…" className="input-field text-xs py-1 w-40" />
                        </div>
                        <div className="max-h-[300px] overflow-y-auto border border-white/[0.08] rounded-lg p-2 space-y-3">
                            {grupos.map(([fonte, nome]) => {
                                const lista = filtradas.filter(m => m.fonte === fonte);
                                if (!lista.length) return null;
                                return (
                                    <div key={fonte}>
                                        <p className="label-overline mb-1">{nome}</p>
                                        <div className="flex flex-wrap gap-1.5">
                                            {lista.map(m => {
                                                const i = w.metrics.indexOf(m.key);
                                                return (
                                                    <button key={m.key} onClick={() => toggleMetric(m.key)} title={m.nota || m.key}
                                                        className={`px-2 py-1 rounded-md text-[11px] border transition ${i >= 0 ? "bg-brand-500/25 border-brand-500/50 text-brand-100" : "bg-surface-2 border-white/[0.08] text-ink-3 hover:text-ink-1"}`}>
                                                        {i >= 0 && tipo.multi && <span className="text-brand-300 mr-1">{i + 1}</span>}{m.label}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs">
                    {(w.tipo === "table" || w.tipo === "bar" || w.tipo === "donut" || w.tipo === "creatives") && (
                        <div>
                            <label className="text-ink-3 mb-1 block">Limite de linhas</label>
                            <input type="number" min={1} max={1000} value={w.opcoes?.limite || ""} onChange={e => setW(x => ({ ...x, opcoes: { ...x.opcoes, limite: e.target.value ? Number(e.target.value) : undefined } }))} className={sel} placeholder="padrão" />
                        </div>
                    )}
                    {(w.tipo === "table" || w.tipo === "bar" || w.tipo === "creatives") && w.dimension !== "dia" && (
                        <div>
                            <label className="text-ink-3 mb-1 block">Ordenar por</label>
                            <select value={w.opcoes?.ordenar || ""} onChange={e => setW(x => ({ ...x, opcoes: { ...x.opcoes, ordenar: e.target.value || undefined } }))} className={sel}>
                                <option value="">1ª métrica</option>
                                {w.metrics.map(k => <option key={k} value={k}>{metricas.find(m => m.key === k)?.label || k}</option>)}
                            </select>
                        </div>
                    )}
                    {w.tipo === "bar" && (
                        <label className="flex items-center gap-2 text-ink-3 pt-5"><input type="checkbox" checked={!!w.opcoes?.horizontal} onChange={e => setW(x => ({ ...x, opcoes: { ...x.opcoes, horizontal: e.target.checked } }))} className="accent-brand-500" /> Barras horizontais</label>
                    )}
                    {w.tipo === "bar" && w.metrics.length > 1 && (
                        <label className="flex items-center gap-2 text-ink-3 pt-5"><input type="checkbox" checked={!!w.opcoes?.empilhado} onChange={e => setW(x => ({ ...x, opcoes: { ...x.opcoes, empilhado: e.target.checked } }))} className="accent-brand-500" /> Empilhadas</label>
                    )}
                    {(w.tipo === "line" || w.tipo === "kpi") && (
                        <label className="flex items-center gap-2 text-ink-3 pt-5"><input type="checkbox" checked={w.opcoes?.compare !== false && (w.tipo === "kpi" || !!w.opcoes?.compare)} onChange={e => setW(x => ({ ...x, opcoes: { ...x.opcoes, compare: e.target.checked } }))} className="accent-brand-500" /> Mostrar período anterior</label>
                    )}
                </div>

                <div className="flex items-center gap-3 pt-1">
                    <button onClick={salvar} disabled={w.tipo !== "texto" && !w.metrics.length} className="btn-primary disabled:opacity-50">Aplicar</button>
                    <button onClick={onFechar} className="btn-ghost">Cancelar</button>
                </div>
            </div>
        </div>
    );
}
